<template>
  <div class="">
    <TransportTypeSwitch class="q-mb-sm"/>
    <div>
      <q-btn
          :label="deliveryValue"
          :class="deliveryValueClass"
          dense
          outline
          size="md"
          class="c-delivery-btn leading-3"
          :to="attrs.TRANSPORT_TYPE === 'courier' ? '/delivery-service?role=vorder&type=profile' : '/delivery-service?role=vorder&type=pickup'"
          :color="deliveryFilled ? undefined : 'primary'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">

import {storeToRefs} from "pinia";
import {computed} from "vue";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import TransportTypeSwitch from "./TransportTypeSwitch.vue";

const vorderState = useVorderState()

const {
  attrs,
  currentPickupOffice,
} = storeToRefs(vorderState)

const deliveryFilled = computed(() => {
  if (attrs.value.TRANSPORT_TYPE === 'courier') {
    return !!attrs.value.ADDRESS
  } else {
    return !!currentPickupOffice.value?.NAME
  }
})

const deliveryValue = computed(() => {
  let val = ''
  if (attrs.value.TRANSPORT_TYPE === 'courier') {
    if (deliveryFilled.value) {
      val = attrs.value.ADDRESS!
    } else {
      return 'выбрать адрес'
    }
  } else {
    if (deliveryFilled.value) {
      val = currentPickupOffice.value?.NAME!
    } else {
      return 'выбрать подразделение'
    }
  }
  return val
})

const deliveryValueClass = computed(() => {
  const cls: any = {}
  if (deliveryValue.value.length < 40) {
    cls['s-font-2xs'] = true
  } else if (deliveryValue.value.length < 80) {
    cls['s-font-3xs'] = true
  } else if (deliveryValue.value.length < 130) {
    cls['s-font-4xs'] = true
  } else {
    cls['s-font-4xs --big-text'] = true
  }
  if (!deliveryFilled.value) {
    cls['--value-empty'] = true
  }
  return cls
})

</script>

<style scoped lang="scss">

.c-delivery-btn {
  max-height: none;
  padding: 4px 9px;
  width: 100%;

  &.q-btn--outline:before {
    border: 1px dashed #dddddd;

  }

  &.--big-text {
    :deep(.block) {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: right;
    }
  }

  &.--value-empty {
    :deep(.block) {

    }
  }
}

</style>
